import timezone from '../assets/timezone.json'

export function getTimezoneId() {
    if (window['Intl']) {
        const result = Intl.DateTimeFormat().resolvedOptions().timeZone
        // IE下部生效
        if (result) {
            return result
        }
    }
    const offset = new Date().getTimezoneOffset()
    let id = ''
    for (let i = 0, len = timezone.length; i < len; i++) {
        const item = timezone[i]
        const [hour, min] = item.offset.split(':')
        if (Number(hour) * 60 + Number(min) + offset === 0) {
            ({ id } = item)
            break
        }
    }
    return id
}
